import "@/index.css";
import { initSentry } from '@partner-spa-vue/instrument';
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { waitUntilReady } from '@/ui-plus/useAuth';
import { pkceCheckAuthParams } from "@/ui-plus/auth/auth.pkce.redirect";

waitUntilReady.then(async () => {
    await pkceCheckAuthParams();
    const app = createApp(App);
    initSentry(app);
    app.use(router);
    app.mount('#app');
});